import { Card } from 'primereact/card'
import { Image } from '../../shared/components'

export function AdvancedCard(props: {
  title: string
  subTitle?: string
  description?: string
  imageSrc?: string
  tag?: string
  footer?: React.ReactNode
  className?: string
  onSelection: () => void
}) {
  const header = props.imageSrc && (
    <Image
      data-testid='hide-in-storybook'
      pt={{ image: { className: 'max-h-[220px] w-full object-cover' } }}
      className='aspect-[3/2] max-h-[220px] w-full object-cover'
      aria-hidden
      src={props.imageSrc}
      alt={props.title}
    />
  )

  return (
    <Card
      onClick={props.onSelection}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          props.onSelection()
        }
      }}
      title={props.title}
      subTitle={props.subTitle}
      header={header}
      className={props.className}
      footer={props.footer}
      role='link'
    >
      {props.description && <p className='m-0'>{props.description}</p>}
    </Card>
  )
}
